<template>
  <div>
    <!--  -->
    <a-upload :multiple="true" :customRequest="handleFileUpload" :file-list="fileList" :before-upload="beforeFileUpload"
      :showUploadList="false" :accept="accept">
      <a-button>
        <a-icon type="upload" />选择文件
      </a-button>
    </a-upload>

    <!-- 预览图片 -->
    <imgView ref="imgView" :src.sync="viewSrc" />
    <!-- <div class="imgUploadView" v-viewer>
      <img v-for="(src,index) in viewImgList" :src="src" :key="index" v-show="false"/>
    </div>-->
  </div>
</template>

<script>
import { fileDeletAPI } from '@/api/file.js'
import { getQRCodeInfo, invoiceSave } from '@/api/payable.js'
import { fileSaveAPI } from '@/api/file.js'
export default {
  name: 'imgUpload',
  props: {
    accept: {
      type: String,
      required: false,
      default: function () {
        return '.png,.PNG,.jpg,.JPG,.jpeg,.JPEG'
      },
    },
    // 文件上传接口的url
    url: {
      type: String,
      required: false,
      default: function () {
        return '/gb-bigtree-file/fileUpload'
      },
    },
    // 上传的文件名称
    name: {
      type: String,
      required: true,
      default: function () {
        return 'fileName'
      },
    },
    // 描述文字
    text: {
      type: String,
      required: false,
      default: function () {
        return '上传图片'
      },
    },
    // 上传数量
    num: {
      type: Number,
      required: false,
      default: function () {
        return 10
      },
    },
    // 可传入接口需要的参数
    paramObj: {
      type: Object,
      required: false,
      default: function () {
        return {}
      },
    },
    //导入参数
    pageData: {
      type: Object,
      required: false,
      default: function () {
        return {}
      },
    },
    file: {
      type: [Object, Array],
      required: false,
    },
    disabled: {
      type: [Boolean],
      required: false,
    },
    removeaction: {
      //删除时是否删除服务器文件
      type: Boolean,
      required: false,
      default: function () {
        return false
      },
    },
  },
  data() {
    return {
      fileList: [],
      uploading: false,
      viewSrc: '',
      viewImgList: [],
      paramObjSelf: this.utils.deepClone(this.paramObj),
      errList: [],
      noRenderItem: ['tenanId', 'buryName', 'buryOrgCode'],
      uploadnum: 0,
      uploadFlag: true,
    }
  },
  methods: {
    beforeFileUpload(file) {
      this.uploadFlag = true
      let obj = {
        file: {
          uid: file.uid,
          name: file.name,
          errmsg: '',
        },
      }
      const isLt4M = file.size / 1024 / 1024 < 4
      if (!isLt4M) {
        this.$message.error('上传文件不能大于4M')
        obj.file.errmsg = '失败，文件过大'
        this.$emit('uploadOk', obj)
        return false
      }
      if (file.name && file.name.indexOf('.') > -1) {
        let d_name = file.name.substring(file.name.lastIndexOf('.') + 1)
        if (this.accept.indexOf(d_name) > -1) {
          this.fileList = [...this.fileList, file];
        } else {
          this.$message.error('请上传' + this.accept + '格式的文件')
          obj.file.errmsg = '失败，文件格式不正确'
          this.$emit('uploadOk', obj)
          return false
        }
      } else {
        this.$message.error('请上传' + this.accept + '格式的文件')
        obj.file.errmsg = '失败，文件格式不正确'
        this.$emit('uploadOk', obj)
        return false
      }
    },
    handleFileUpload(file) {
      if (this.fileList.length > this.num && this.uploadFlag) {
        this.uploadFlag = false
        this.$message.warning(`选择文件不能超过${this.num}个`)
        this.fileList = []
        this.uploadnum = 0
        return false
      }
      if (this.uploadFlag) {
        this.uploadnum++
        const formData = new FormData()
        formData.append(this.name, file.file)
        for (let key in this.paramObjSelf) {
          formData.append(key, this.paramObjSelf[key])
        }
        this.uploading = true
        this.axios({
          url: this.url,
          data: formData,
          isTransform: false,
        })
          .then((res) => { })
          .catch((data) => {
            // this.uploading = false
            if (data[0]) {
              let obj = {
                name: file.file.name,
                size: file.file.size,
                uid: file.file.uid,
                fileExpdNm: data[0].contentType,
                fileRte: JSON.parse(data[0].savePath).file,
              }
              file.onSuccess()
              file.status = 'done'
              this.fileSave(obj)
            } else {
              file.onError()
              file.status = 'error'
            }
          })
      }
    },
    fileSave(data) {
      const param = {
        fileNm: data.name,
        fileSize: data.size,
        fileRte: data.fileRte,
        fileExpdNm: data.fileExpdNm,
        tblBlId: this.paramObjSelf.tblBlId,
        mdlId: 'payable',
        useCase: 'supplier',
      }
      fileSaveAPI(param)
        .then((res) => {
          this.getQRCodeInfo(res.data.fileId, data)
          this.uploadnum--
          if (this.uploadnum === 0) {
            this.fileList = []
          }
        })
        .catch((err) => {
          this.uploadnum--
          if (this.uploadnum === 0) {
            this.fileList = []
          }
          this.uploading = false
        })
    },
    getQRCodeInfo(fileId, file) {
      let obj = {
        fileId: fileId,
        file: {
          ...file,
          errType: 1,
          errmsg: '',
        },
      }
      getQRCodeInfo({ fileId: fileId }, true)
        .then((res) => {
          if (!res.data) {
            obj.file.errmsg = '失败，识别失败'
            this.$emit('uploadOk', obj)
            return
          }
          let params = {
            ...res.data,
            ...this.pageData,
            tblBlId: this.paramObj.tblBlId,
            invoiceId: fileId,
            fileId: fileId,
            payableAmount:res.data.payableAmount || res.data.invoiceAmountWithVat || 0,
            canEstbGldBal:res.data.payableAmount || res.data.invoiceAmountWithVat || 0,
          }
          let row = {
            ...obj,
            ...res.data
          }
          this.importTable(params, row)
        })
        .catch((err) => {
          obj.file.errmsg = '失败，识别失败'
          this.$emit('uploadOk', obj)
          this.uploading = false
        })
    },
    // 导入列表
    importTable(obj, row) {
      invoiceSave(obj)
        .then((res) => {
          this.$emit('uploadOk',res.data)
        })
        .catch((err) => {
          row.file.errType = 2
          row.file.errmsg = err.description
          this.$emit('uploadOk', row)
        })
    },
  },
  watch: {
    paramObj: {
      deep: true,
      handler(newVal) {
        this.paramObjSelf = this.utils.deepClone(newVal)
      },
    },
    // file: {
    //   deep: true,
    //   handler(newVal) {
    //     if (newVal && JSON.stringify(newVal) != '{}') {
    //       this.fileList = [
    //         {
    //           uid: newVal.fileId || newVal.uid,
    //           name: newVal.fileNm || newVal.name,
    //           status: 'done',
    //           url:
    //             '/gb-bigtree-file/download/fileDownload/install' +
    //             newVal.fileRte +
    //             '/' +
    //             (newVal.fileNm || newVal.name),
    //         },
    //       ]
    //     } else {
    //       this.fileList = []
    //     }
    //   },
    // },
  },
}
</script>
<style scoped>
.img-icon {
  font-size: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/invoiceUpload/index.vue